import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { extrasApi } from '../api/extras.api';
import type { CreateExtraRuleDto } from '../types';

export const useExtras = () => {
  return useQuery({
    queryKey: ['extras'],
    queryFn: () => extrasApi.getAll(),
  });
};

export const useExtra = (id: number) => {
  return useQuery({
    queryKey: ['extras', id],
    queryFn: () => extrasApi.getOne(id),
    enabled: !!id,
  });
};

export const useCreateExtra = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateExtraRuleDto) => extrasApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['extras'] });
      notifications.show({
        title: 'Успешно',
        message: 'Правило успешно создано',
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Ошибка',
        message: error?.response?.data?.message || 'Не удалось создать правило',
        color: 'red',
      });
    },
  });
};

export const useDeleteExtra = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => extrasApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['extras'] });
      notifications.show({
        title: 'Успешно',
        message: 'Правило успешно удалено',
        color: 'green',
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: 'Ошибка',
        message: error?.response?.data?.message || 'Не удалось удалить правило',
        color: 'red',
      });
    },
  });
};
